import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
//import Data from "../../assets/jsons/user";
import {
  onShowSizeChange,
  itemRender,
  showTotal
} from "../_components/paginationfunction";
import api from "../api/api"

import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import AddVendor from "./AddVendor";
import VendorListMobile from "./VendorListMobile";
import { useTranslation } from "react-i18next";
import { set } from "react-hook-form";
const VendorDirectory = () => {
  const {user} = useAuth();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(()=>{
    fetchData()
  },[])

  const [loadingSuppliers, setloadingSuppliers] = useState(false);
  const [error, setError] = useState(null);
  
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  const fetchData = async (page = 1) => {  
    setloadingSuppliers(true)
    setError(null)
      
    try {
      let typeurl = `/vendor-list/?page=${page}`;

      const response = await api.get(typeurl); // No need to wrap `data` in an object

      
      console.log("Response Code:", response.status);

      setData(response.data.results)
      setNextPage(response.data.next)
      setPrevPage(response.data.previous)
      setCount(response.data.count)
      
      } catch (error) {
        console.log( error);
        // Extract response code if available
        const responseCode =  "Unknown";
        
        setError(responseCode)
        console.log("Response Code:", responseCode);
      } finally {
        setloadingSuppliers(false);
      }
  }

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) return;

    setCurrentPage(page);
    fetchData(page);
  };

  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns = [
    {
      title: "#",
      //dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: false,
    },
    {
      title: t("Vendor Name"),
      dataIndex: "name",
      render: (img, record) => (
        <div>
          <h2 className="table-avatar">
              {record.name} 
          </h2>
        </div>
      ),
     
    },
    {
      title: t("Email"),
      dataIndex: "email",
      
    },
    {
      title: t("Contact"),
      dataIndex: "phone",
      
    },
    {
      title: t("Location"),
      dataIndex: "location",
      
    },
  ];

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  useEffect(() => {
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
        window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
        {(loadingSuppliers || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingSuppliers && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
          <> 
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header ">
                <h5>{t("Vendor list")}</h5>
                {
                  user.role == "Admin" && <>
                    <div className="list-btn">
                      <ul className="filter-list">
                        <li>
                          <a
                            className="btn btn-primary"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#add_vendor"
                          >
                          <i
                            className="fa fa-plus-circle me-2"
                            aria-hidden="true"
                          />
                          {t("Add Vendor")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </>
                }
              </div>
            </div>
            {/* /Page Header */}
            
            {data.length === 0 && (
              <div className="text-center mt-5 py-5">
                <div className="mb-4">
                  <div className="mb-3">
                    <i className="fas fa-store text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                  </div>
                  <h4 className="text-muted mb-2">{t("No Vendors Available")}</h4>
                  <p className="text-muted mb-4">{t("You don't have any vendors in your list yet.")}</p>
                </div>
                {user.role === "Admin" && (
                  <div className="d-flex gap-3 justify-content-center flex-wrap">
                    <a
                      className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#add_vendor"
                    >
                      <i className="fas fa-plus me-2"></i>
                      {t("Add Vendor")}
                    </a>
                  </div>
                )}
              </div>
            )}

            <div className="row">
              <div className="col-sm-12">
                {isMobileDevice() || screenWidth <= 576 ? (
                  <>
                    <VendorListMobile handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data} screenWidth={screenWidth}/>
                  </>
                ) : (
                  <div className="card-table">
                    <div className="card-body">
                      <div className="table-responsive table-hover">
                        <Table
                          pagination={{
                            total: count,
                            current: currentPage,
                            onShowSizeChange: onShowSizeChange,
                            showTotal: (length,range) => showTotal(t,length, range),
                            itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                          }}
                          columns={columns}
                          dataSource={data}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          </>
        )}
        </div>
        {/* add vendor */}
        <AddVendor />
        {/* add vendor */}
      </div>
    </>
  );
};

export default VendorDirectory;
